import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getImageUrl } from '../services/api';
import './Header.css';

const Header = ({ language, changeLanguage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      } else {
        setUser(null);
      }
    };

    checkAuth();
    // Listen for storage changes and custom auth event
    window.addEventListener('storage', checkAuth);
    window.addEventListener('authChange', checkAuth);
    return () => {
      window.removeEventListener('storage', checkAuth);
      window.removeEventListener('authChange', checkAuth);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.dispatchEvent(new Event('authChange'));
    navigate('/');
  };

  const translations = {
    ru: {
      lk: 'Личный кабинет',
      enter: 'Войти',
      podder: 'Поддержать',
      profile: 'Мой профиль',
      logout: 'Выход',
      menu: [
        { name: 'Объявления', href: '/work' },
        { name: 'Подать объявление', href: '/#findBlock' }
      ]
    },
    en: {
      lk: 'Personal account',
      enter: 'Login',
      podder: 'To support',
      profile: 'My Profile',
      logout: 'Logout',
      menu: [
        { name: 'Ads', href: '/work' },
        { name: 'Submit ad', href: '/#findBlock' }
      ]
    }
  };

  const t = translations[language] || translations.en;

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    changeLanguage(newLang);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSubmitAdClick = (e) => {
    e.preventDefault();
    if (user) {
      navigate('/profile?tab=ads');
    } else {
      navigate('/auth');
    }
  };

  return (
    <>
      <header className="desktop">
        <div className="container">
          <div className="row">
            <div className="logo">
              <Link to="/">
                <img src="/local/templates/kapussta/img/logo_white.svg" alt="logo" />
              </Link>
            </div>
            <div className="menu">
              <ul>
                {t.menu.map((item, index) => (
                  <li key={index}>
                    {item.name === 'Подать объявление' || item.name === 'Submit ad' ? (
                      <a href={item.href} onClick={handleSubmitAdClick}>{item.name}</a>
                    ) : (
                      <Link to={item.href}>{item.name}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="prof_lang">
              <div className="lang_select">
                <select id="lang" name="Lang" value={language} onChange={handleLanguageChange}>
                  <option value="ru">RU</option>
                  <option value="en">EN</option>
                </select>
              </div>

              {user && (
                <div className="user-profile-menu">
                  <div className="profile-trigger">
                    <div className="header-avatar">
                      {user.avatar ? (
                        <img src={getImageUrl(user.avatar)} alt="avatar" className="avatar-img" />
                      ) : (
                        (user.name || user.NAME) ? (user.name || user.NAME).charAt(0).toUpperCase() : (user.login || user.LOGIN ? (user.login || user.LOGIN).charAt(0).toUpperCase() : '?')
                      )}
                    </div>
                  </div>
                  <div className="profile-dropdown">
                    <Link to="/profile" className="dropdown-item">{t.profile}</Link>
                    <button onClick={handleLogout} className="dropdown-item logout-btn">{t.logout}</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      <header className="mobile">
        <div className="container">
          <div className="row">
            <div className="logo">
              <Link to="/">
                <img src="/local/templates/kapussta/img/logo_white.svg" alt="logo" />
              </Link>
            </div>
            <div className="header-actions">
              {user && (
                <Link to="/profile" className="header-avatar small">
                  {user.avatar ? (
                    <img src={getImageUrl(user.avatar)} alt="avatar" className="avatar-img" />
                  ) : (
                    (user.name || user.NAME) ? (user.name || user.NAME).charAt(0).toUpperCase() : (user.login || user.LOGIN ? (user.login || user.LOGIN).charAt(0).toUpperCase() : '?')
                  )}
                </Link>
              )}
              <div id="nav-icon3" className={isMenuOpen ? 'open' : ''} onClick={toggleMenu}>
                <span></span><span></span><span></span><span></span>
              </div>
            </div>

            <div className={`openBlock ${isMenuOpen ? 'open' : ''}`}>
              <div className="menu">
                <ul>
                  {t.menu.map((item, index) => (
                    <li key={index}>
                      {item.name === 'Подать объявление' || item.name === 'Submit ad' ? (
                        <a href={item.href} onClick={(e) => { toggleMenu(); handleSubmitAdClick(e); }}>{item.name}</a>
                      ) : (
                        <Link to={item.href} onClick={toggleMenu}>{item.name}</Link>
                      )}
                    </li>
                  ))}
                  {user && (
                    <li key="logout"><button onClick={() => { toggleMenu(); handleLogout(); }} className="mobile-logout-btn">{t.logout}</button></li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;


